/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsLocaleModule,
    MelcoModelsLocaleModuleFromJSON,
    MelcoModelsLocaleModuleFromJSONTyped,
    MelcoModelsLocaleModuleToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsLocaleModule
 */
export interface MelcoModelsGenericList1MelcoModelsLocaleModule {
    /**
     * 
     * @type {Array<MelcoModelsLocaleModule>}
     * @memberof MelcoModelsGenericList1MelcoModelsLocaleModule
     */
    list: Array<MelcoModelsLocaleModule>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsLocaleModule
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsLocaleModule
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsLocaleModuleFromJSON(json: any): MelcoModelsGenericList1MelcoModelsLocaleModule {
    return MelcoModelsGenericList1MelcoModelsLocaleModuleFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsLocaleModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsLocaleModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsLocaleModuleFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsLocaleModuleToJSON(value?: MelcoModelsGenericList1MelcoModelsLocaleModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsLocaleModuleToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


